<template>
<div>

	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading show="false" :showBack="true" :pageTitle="'HEADER-'+siteTitle"></page-heading>

        <div class="columns">

			<div class="col-main">

				<div class="box">

					<template v-for="(category, index) in siteCatalogContentCategories" v-if="inCategory(category.id)">

						<div :id="category.name" class="control groupTitle">
							<div class="control-label">
								<lang :labelKey="'APO_CATEGORY-'+category.name"></lang>
							</div>
						</div>

						<div class="columns">

							<div class="column is-narrow">

								<template v-for="customization in siteCatalog.siteCatalogCustomizations" v-if="customization.type == category.data.catalogPageCustomization">

									<div :class="['previewWrapper', category.name]">

										<div v-if="customization.preview != null" :class="index">
											<div v-if="customization.preview != null" class="preview lazyImg lazy-img-fadein" v-lazy:background-image="getImgUrl(customization)"></div>
										</div>

										<div v-else class="preview noImg"></div>

									</div>

								</template>

							</div>

							<div class="column">

								<div class="control">
									<div class="control-label">
										<label-name labelKey="APO-UPLOAD_BOX-LABEL"></label-name>
									</div>
									<div class="control">

										<vue-dropzone
											:ref="'vueDropzone'+category.id"
											:id="'vueDropzone'+index"
											url= "fileProcessing/upload?preset=siteCatalogAsset"
				                            :maxFiles="25"
											:isEnabled="userRole!='Kundenbetreuer'"
											:formDataAppend = "[{ category: category.id }]"
				                            dictDefaultMessage="<i class='fa fa-cloud-upload'></i>hochladen"
					                        v-on:vdropzone-success="dzSuccess($event, category.id)"
											dzClass="default">
										</vue-dropzone>
									</div>
								</div>

								<template v-if="siteCatalog.siteCatalogAssets.length > 0">

									<div class="control is-horizontal">

										<div class="control">
											<assets :assets="siteCatalog.siteCatalogAssets" :specialCondition="true" :conditionId="category.id" @removeAsset="removeImageAsset($event, category.id)"></assets>
										</div>
									</div>

								</template>

								<!-- textbox -->
								<div class="control topMargin is-clearfix">
						            <div class="control-label">
						                <label-name :labelKey="category && category.name == 'U4' ? 'APO-NEW_CONTENT_FIELD-U4' : 'APO-NEW_CONTENT_FIELD'"></label-name>
						            </div>
						            <div class="control">
						                <textarea :class="[{'is-disabled': isApproved }, 'textarea is-medium']" type="text" v-model="textFields[index]"></textarea>
							        </div>
									<div class="control">
										<button :class="[{'is-loading': isSaving, 'is-disabled': isApproved }, 'button is-normal is-pulled-right']" @click="addContentField(category.id, key, index)">{{ $t('APO_VIEW-TEXTBOX_ADD') }}</button>
									</div>
						        </div>

								<!-- Text Fields -->
								<content-segment
									:catalogContents="siteCatalog.siteCatalogContents"
									:categoryId="category.id"
									@addTextBox="addContentField"
									@removeTextBox="removeContentField"
									v-model="siteCatalog">
								</content-segment>

							</div>

						</div>


					</template>

				</div>


				<!-- comments -->
				<comments headerTitle="APO_DETAIL-COMMENTS_HEADER" :threadID.sync="currentSiteCatalogCustomization.thread" :api="'siteCatalogCustomization/'+currentSiteCatalogCustomization.id"></comments>

            </div>


            <div class="col-aside">

                <affix :offset="50">

                    <div class="sidebox">

                        <custom-button type="blue" icon="icon-ak-speichern" name="PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="submitForm(false, true)" :disabled="isApproved"></custom-button>

						<a :href="downloadURL" download v-if="currentSiteCatalogCustomization.preview != null">
							<custom-button type="dark" icon="icon-ak-download" name="PDF"></custom-button>
						</a>

						<!--
						<custom-button :loading="isPrintApproving" :class="[{'is-disabled': isPrintApproved}, 'is-success']" icon="icon-ak-freigaben" @click.native="printApprove()" name="CUSTOMIZATION-PRINT_APPROVE"></custom-button>
						-->

					</div>

                </affix>

            </div>


        </div>

    </template>

</div>


</template>



<script>
import vue2Dropzone from '../../utils/dropzoneWrapper'
import assets from '../../utils/incl-assets';
import contentSegment from './EditMutationSegment';
import comments from '../../utils/incl-comments';
export default {

    components: {
		vueDropzone: vue2Dropzone,
		contentSegment,
		comments,
		assets
    },

    data(){
		return {
            isLoading: false,
            isSaving: false,

            dzHeaders: { "Cache-Control": "", "X-Requested-With": "", "Authorization": 'Basic ' + localStorage.getItem('token')},
			dzLangObj: {
				dictDefaultMessage: 'Datei wählen oder per Drag & Drop hinzufügen',
				dictCancelUpload: 'abbrechen',
				dictRemoveFile: 'x'
		 	},
			textFields: [],
			newContentField: {
				category: '',
				siteCatalog: '',
				content: ''
			},
			taxonomies: [],
			currentSiteCatalogCustomization: {},
			siteCatalogContent: [],
			siteCatalogAsset: [],
			siteCatalogCustomization: {},
			siteCatalog: {},
			siteCatalogCats: [],
			siteTitle: null
		}
	},

	computed: {

		isApproved() {
			return this.siteCatalog.status.name == 'APPROVED' || this.siteCatalog.status.name == 'PRINT_APPROVED';
		},

		siteCatalogContentCategories() {
            return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES');
        },

		siteCatalogCustomizations() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATIONS');
		},

		siteCatalogCustomizationStatus() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATION_STATUS');
		},

		siteCatalogContentsComputed() {
			return this.siteCatalog.siteCatalogContents;
		},

		downloadURL() {

			var asset = this.$config.assets + this.currentSiteCatalogCustomization.preview.path + '/' + this.currentSiteCatalogCustomization.preview.filename;
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

		},

	},

	created() {

		if(this.$route.params.siteCatalogID && this.$route.params.catID) {

			// set site title
			this.siteTitle = this.$route.params.catID;

			// fetch data
            this.fetchData();

		}

    },

	mounted() {


	},

    methods: {

		getAssets(assets, catId) {

			return assets.filter(asset => asset.category == catId);

		},

		getImgUrl(customization) {
			return this.$config.assets +  customization.preview.path + '/' +  customization.preview.filename;
		},

		getPdfDownloadUrl(customization) {

			var asset = this.getImgUrl(customization);
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

		},


		// add and remove content Fields
		// ---------------------------------------------------------------------
		addContentField(catId, key, index) {

			if(this.isApproved == true) {
				this.$notify.open({content: 'Der Status dieser Seite wurde bereits auf "Freigegeben" gesetzt. Eine Änderung ist nicht mehr möglich!', type: 'warning'});
				return false;
			}

			this.isSaving = true;

			if(this.textFields[index] == undefined || this.textFields[index].length < 3) {
				this.$notify.open({content: 'Bitte geben Sie mindestens drei Zeichen ein!', type: 'warning'});
				this.isSaving = false;
				return;
			}

			this.newContentField.content = this.textFields[index];
			this.newContentField.category = catId;
			this.newContentField.siteCatalog = this.siteCatalog.id;


			this.siteCatalog.siteCatalogContents.push(this.newContentField);
			this.newContentField = {};
			this.textFields[index] = '';

			this.submitForm();

		},

		removeContentField(index) {

			this.siteCatalog.siteCatalogContents.splice(index, 1);
			this.submitForm();

		},

		contentFieldLabel(index) {
			return "Text " + ++index;
		},

		inCategory(catId) {

			if(this.siteCatalogCats.indexOf(catId) != -1) {
				return true;
			}

			return false;

		},


		dzSuccess(file, catId) {

			var result = JSON.parse(file.xhr.response);

			var newAsset = {
				category: catId,
				siteCatalog: this.siteCatalog.id,
				asset: {
					filename: result.fileName,
					path: result.dir
				}
			}

			// push newly created obj into assets Array
			this.siteCatalog.siteCatalogAssets.push(newAsset);

			// remove image from dropzone after some time
			var x = this.$refs['vueDropzone'+catId][0].$children[0];
			setTimeout(function() {
				x.removeFile(file);
			}, 1200)

		},

		removeImageAsset(asset, catId) {

			let assetIndex = this.siteCatalog.siteCatalogAssets.findIndex(as => as.asset.filename == asset.asset.filename);
			this.siteCatalog.siteCatalogAssets.splice(assetIndex,1);

		},

		submitForm(isSilent=true, redirect=false) {

			var self = this;
            this.entityCreateOrUpdate('siteCatalog', this.siteCatalog, {isSilent: isSilent}).then(function() {

				if(redirect) {
					self.$router.go(-1);
				}

			})

		},


		getCurrentSiteCatalogCustomizationThreadId(customizations) {

			for(var i = 0; i < customizations.length; i++) {
				if(customizations[i].type == this.siteCatalogCustomizations[this.$route.params.catID].id) {
					this.currentSiteCatalogCustomization = customizations[i];
					break;
				}
			}

		},


		fetchData() {

			this.isLoading = true;

			var self = this,
				siteCatalogID = this.$route.params.siteCatalogID;

			var cats = [];
	        switch(this.$route.params.catID) {

	            case "U1_U4":
	                cats.push(this.siteCatalogContentCategories.U1.id,this.siteCatalogContentCategories.U4.id);
	                break;

	            case "U2":
	                cats.push(this.siteCatalogContentCategories.U2.id);
	                break;

	            case "US":
	                cats.push(this.siteCatalogContentCategories.US_PAGE_1.id, this.siteCatalogContentCategories.US_PAGE_2.id);
	                break;
	        }
			this.siteCatalogCats = cats;
			var catsList = cats.join();


			this.entitiesGet([
				{
					key: 'taxonomy',
					params: {
						'filters[name]': ['SITE_CATALOG_CUSTOMIZATION_PACKAGES', 'SITE_CATALOG_CUSTOMIZATION_EXPENSES', 'SITE_CATALOG_CUSTOMIZATIONS', 'SITE_CATALOG_CONTENT_CATEGORIES'].join(','),
						'include': 'taxonomy.taxonomyTerms',
					}
				},
				{
					key: 'siteCatalog',
					params: {
						'filters[catalog.isActive]': 1,
						'filters[id]': siteCatalogID,
						'include': [
							'siteCatalog.siteCatalogAssets',
							'siteCatalog.siteCatalogContents',
							'siteCatalog.site',
							'siteCatalog.siteCatalogCustomizations',
							'siteCatalog.catalog',
							'siteCatalogAsset.asset',
							'siteCatalog.voucherPreview',
							'siteCatalogCustomization.preview',
							'siteCatalog.status'
						].join(',')
					}
				}
			])
				.then(function(results) {

					var i;

					self.siteCatalog = results.siteCatalog[0];
					self.getCurrentSiteCatalogCustomizationThreadId(results.siteCatalog[0].siteCatalogCustomizations);

					// convert taxonomies result to hash table for easy access
					self.taxonomies = self.createTaxonomiesHashTable(results.taxonomy);

					// prepare siteCatalogCustomization if necessary
					// we need to make sure we have three entries of the types U1_U4, U2 and US
					// these types are provided by the SITE-CATALOG-CUSTOMIZATIONS taxonomy
					Object.keys(self.taxonomies.SITE_CATALOG_CUSTOMIZATIONS).forEach(function(key) {

						// check if a customization of this type already exists, otherwise create one
						var siteCatalogCustomizationType = self.taxonomies.SITE_CATALOG_CUSTOMIZATIONS[key],
							exists = self.siteCatalog.siteCatalogCustomizations.filter(function(siteCatalogCustomization) {

								return siteCatalogCustomization.type == siteCatalogCustomizationType.id;

							}).length > 0;

						if (!exists) {

							self.siteCatalog.siteCatalogCustomizations.push({
								siteCatalog: self.siteCatalog.id,
								changeExpendituresAmount: self.taxonomies.SITE_CATALOG_CUSTOMIZATION_EXPENSES.NONE,
								type: siteCatalogCustomizationType.id
							});

						}

					});

				});

		}


    }

}

</script>

<style>

	.control.topMargin {
		margin-top: 50px !important;
	}

	/* @overwrite */
	.control.comments .smallView.commentsContainer {
		margin-top: 5px !important;
		padding: 0;
		width: 100%;
	}
	.control.comments .NewComment .control {
		margin-bottom: 5px !important;
	}

</style>

<style scoped>

	.previewWrapper {
		position: relative;
		margin-right: 5px;
		width: 20vw;
		height: 20vw;
		min-height: 200px;
		min-width: 200px;
	}
	.preview {
		position: absolute;
		background-repeat: no-repeat;
		background-position: left;
	    top: 0; left: 0; right:0; bottom:0;
	    width: 100%;
		height: 100% !important;
		overflow: hidden;
		border-radius: 2px;
	}

	.previewWrapper.US_PAGE_1,
	.previewWrapper.US_PAGE_2 {
		/*height: 37vw;*/
	}
	.previewWrapper.U1 .preview,
	.previewWrapper.US_PAGE_1 .preview {
		background-size: 200% auto;
		background-position: 0 0;
	}
	.previewWrapper.U2 .preview {
		background-size: 100% auto;
		background-position: 0 0;
	}
	.previewWrapper.U4 .preview,
	.previewWrapper.US_PAGE_2 .preview {
		background-size: 200% auto;
		background-position: right top;
	}

	.previewWrapper .preview.noImg,
	.previewWrapper.U1 .preview[lazy=error],
	.previewWrapper.U2 .preview[lazy=error]
	.previewWrapper.U4 .preview[lazy=error],
	.previewWrapper.US_PAGE_1 .preview[lazy=error],
	.previewWrapper.US_PAGE_2 .preview[lazy=error] {
		background: #fff url('../../../assets/img/bg-preview_customization.jpg') center no-repeat !important;
		background-size: 100% !important;
	}

	.previewWrapper .preview[lazy=loading] {
		background-size: 100px !important;
        background-position: 50% 50% !important;
	}

	.notification.is-info {
		background: #f5f5f5;
		color: #b70000;
		font-size: 15px;
	}

</style>
